(function () {
  var SELECTOR = '#sas-carrousel';
  var INTERVAL = 5000;
  var TRIGGER_EVENTS = ['pointerdown', 'touchstart', 'keydown', 'wheel', 'scroll', 'mousemove'];
  var LISTENER_OPTIONS = { once: true, passive: true };
  var started = false;

  function removeTriggers() {
    TRIGGER_EVENTS.forEach(function (type) {
      window.removeEventListener(type, start, LISTENER_OPTIONS);
    });
  }

  function carouselReady() {
    return !!(window.jQuery && window.jQuery.fn && window.jQuery.fn.carousel);
  }

  function start() {
    if (started) return;

    if (!document.querySelector(SELECTOR)) {
      started = true;
      removeTriggers();
      return;
    }

    if (!carouselReady()) {
      window.addEventListener('load', start, { once: true });
      return;
    }

    started = true;
    removeTriggers();

    window.jQuery(SELECTOR).carousel({ interval: INTERVAL, ride: 'carousel' });
  }

  window.startHeroCarousel = start;

  TRIGGER_EVENTS.forEach(function (type) {
    window.addEventListener(type, start, LISTENER_OPTIONS);
  });
})();
